<div
  rvSpinner="schedule-loader"
  [rvShowSpinner]="scheduleService.loadingSchedule"
  role="main"
>
  <form
    #scheduleForm="ngForm"
    id="forms.scheduleForm"
    role="form"
    name="forms.scheduleForm"
    (ngSubmit)="save()"
    autocomplete="on"
    novalidate
  >
    <common-actions
      [(title)]="scheduleService.schedule.name"
      [titleAriaLabel]="'Edit schedule name'"
      [actions]="actions"
      [saving]="scheduleService.savingSchedule"
    >
    </common-actions>

    <div
      class="tw-border-t tw-border-x-0 tw-border-b-0 tw-border-solid tw-border-gray-200"
    >
      <schedule-fields></schedule-fields>
    </div>
  </form>
  <!-- scheduleForm -->
</div>
<!--container-->
